import React from 'react';

const LogoIcon = () => (
  <img
    src="/Logo-05.png"
    alt="Cubeangle"
    style={{ height: 44, width: 44, objectFit: 'contain' }}
  />
);

export default LogoIcon;
